import {
    ColoursObj,
    getContrastYIQ,
    Typography,
} from '@eventr/common-storybook'
import { useMemo } from 'react'
import { useSectionV2Context } from '../v2/state/sectionProvider'

interface ICountLabelProps {
    id?: string
    text?: number
    bgColor?: string
}

export const CountLabel = ({ id, text, bgColor }: ICountLabelProps) => {
    const { isPublic } = useSectionV2Context()

    const backgroundColor = useMemo(() => {
        if (bgColor) return bgColor
        if (isPublic) return ColoursObj.coreBrights.tertiary
        return ColoursObj.backgrounds.secondary
    }, [isPublic, bgColor])

    if (!text || text === null || text === undefined) {
        return null
    }
    return (
        <Typography
            id={id + 'CounterId'}
            sx={{
                padding: '4px 8px',
                gap: '8px',
                borderRadius: '4px',
                background: backgroundColor,
                lineHeight: '16px',
                fontWeight: '300',
                fontSize: '12px',
                height: 'fit-content',
                width: '8px',
                display: 'flex',
                justifyContent: 'center',
                color: getContrastYIQ(backgroundColor),
            }}
            variant="bodyBold"
        >
            {text.toString() ?? 0}
        </Typography>
    )
}
